/* eslint-disable */
import get from 'lodash/get';
import extend from 'lodash/extend';
import capitalize from 'lodash/capitalize';
import map from 'lodash/map';
import axios from 'axios';
import {canUseDOM} from 'exenv';
import log from '../services/logger_service';
import analyticsConfig from '../../server/config/analytics';
import { figureOutPriorityTag } from '../../utils/ad_util';
import P from 'bluebird';

export class ThirdPartyJs {
  static loadOmniture(currentState, pageNumber) {
    if(canUseDOM) {
      if (window.fastco_s) {
        const siteConfig = analyticsConfig[get(currentState, 'context.site')];
        const omnitureConfig = get(analyticsConfig[siteConfig], 'omniture');
        const siteSlug = get(siteConfig, 'slug');
        const context = get(currentState, 'context');

        const {
          postData,
          tagPageData,
          categoryPageData,
          authorPageData,
          searchPageData,
          staticPageData,
          mostCreativePeoplePageData,
          personPageData,
          ibdPageData,
          type
        } = context;

        let category = '';
        let tag = '';

        // Omniture data structure, defaults to homepage value
        // it will be further extended depend on page type
        let omniture = {
          server: siteSlug,
          channel: 'homepage',
          pageName: `${siteSlug}:homepage:front`,
          pageURL: get(siteConfig, 'url'),
          events: 'event9',
          prop1: '',
          prop2: '',
          prop3: '',
          prop4: get(siteConfig, 'url'),
          prop5: '',
          prop6: '',
          prop7: '',
          prop8: '',
          prop9: '',
          prop10: '',
          prop11: '',
          prop13: 1,
          prop21: 'anonymous',
          prop22: `anonymous:${siteSlug}:homepage:front`,
          prop23: 'anonymous',
          prop28: '',
          prop31: '',
          prop32: '',
          prop33: '',
          prop34: '',
          eVar49: 1
        };

        // Post Page
        if (type === 'post') {
          category = get(postData, 'categories[0].slug');
          const tags = get(postData, 'tags');
          const eyeBrowText = figureOutPriorityTag(tags);
          const postID = get(postData, 'id');
          const postSlug = get(postData, 'slug');

          // For mapping of language, anaytics need to be consistent, language wise
          const typeMap = {
            standard: 'article',
            gallery: 'slideshow',
            video: 'video'
          };

          const pageType = typeMap[get(postData, 'format')] || 'article';

          // Extend original omniture variable
          omniture = extend({}, omniture, {
            pageName: `${siteSlug}:${postID}:${postSlug}`,
            pageURL: `${get(siteConfig, 'url')}/${postID}/${postSlug}`,
            channel: '',
            prop1: category,
            prop2: category,
            prop3: get(postData, 'title'),
            prop4: `${get(siteConfig, 'url')}/${postID}/${postSlug}`,
            prop5: get(eyeBrowText, 'slug'),
            prop6: get(eyeBrowText, 'slug'),
            prop7: '',
            prop8: get(postData, 'author.name'),
            prop9: get(postData, 'omnitureDate'),
            prop10: postID,
            prop11: get(postData, 'author.name'),
            prop22: `anonymous:${siteSlug}:${postID}:${postSlug}`,
            prop28: pageType,
            prop31: '',
            prop32: '',
            prop33: capitalize(category),
            prop34: get(postData, 'readTime')
          });
        } else if (type === 'category') {
          category = get(categoryPageData, 'slug');
          omniture = extend({}, omniture, {
            channel: category,
            pageName: `${siteSlug}:${category}:front`,
            pageURL: `${get(siteConfig, 'url')}/${category}`,
            url: `${get(siteConfig, 'url')}/${category}`,
            prop1: '',
            prop2: '',
            prop3: '',
            prop4: `${get(siteConfig, 'url')}/${category}`,
            prop5: '',
            prop6: '',
            prop7: '',
            prop8: '',
            prop9: '',
            prop10: '',
            prop11: '',
            prop22: `anonymous:${siteSlug}:${category}:front`,
            prop28: '',
            prop31: '',
            prop32: '',
            prop33: '',
            prop34: ''
          });
        } else if (type === 'tag') {
          tag = get(tagPageData, 'slug');
          omniture = extend({}, omniture, {
            channel: tag,
            pageName: `${siteSlug}:taxonomy:${tag}`,
            pageURL: `${get(siteConfig, 'url')}/section/${tag}`,
            url: `${get(siteConfig, 'url')}/section/${tag}`,
            prop1: '',
            prop2: '',
            prop3: get(tagPageData, 'name'),
            prop4: `${get(siteConfig, 'url')}/section/${tag}`,
            prop5: tag,
            prop6: tag,
            prop7: '',
            prop8: 'Fast Company Contributor',
            prop9: '',
            prop10: '',
            prop11: 'Fast Company Contributor',
            prop22: `anonymous:${siteSlug}:taxonomy:${tag}`,
            prop28: 'tag',
            prop31: '',
            prop32: '',
            prop33: '',
            prop34: ''
          });
        } else if (type === 'author') {
          const authorSlug = get(authorPageData, 'slug');
          const authorName = get(authorPageData, 'name');
          omniture = extend({}, omniture, {
            channel: '',
            pageName: `${siteSlug}:user:${authorSlug}`,
            pageURL: `${get(siteConfig, 'url')}/user/${authorSlug}`,
            url: `${get(siteConfig, 'url')}/user/${authorSlug}`,
            prop1: '',
            prop2: '',
            prop3: authorName,
            prop4: `${get(siteConfig, 'url')}/user/${authorSlug}`,
            prop5: '',
            prop6: '',
            prop7: '',
            prop8: authorName,
            prop9: '',
            prop10: '',
            prop11: authorName,
            prop22: `anonymous:${siteSlug}:user:${authorSlug}`,
            prop28: 'user',
            prop31: '',
            prop32: '',
            prop33: '',
            prop34: ''
          });
        } else if (type === 'search') {

          const searchQuery = get(searchPageData, 'query.queryString');

          omniture = extend({}, omniture, {
            channel: '',
            pageName: `${siteSlug}:search:${searchQuery}`,
            pageURL: `${get(siteConfig, 'url')}/search/${searchQuery}`,
            prop1: '',
            prop2: '',
            prop3: searchQuery,
            prop4: `${get(siteConfig, 'url')}/search/${searchQuery}`,
            prop5: searchQuery,
            prop6: searchQuery,
            prop7: '',
            prop8: '',
            prop9: '',
            prop10: '',
            prop11: '',
            prop22: `anonymous:${siteSlug}:search:${searchQuery}`,
            prop28: 'search',
            prop31: '',
            prop32: '',
            prop33: '',
            prop34: ''
          });
        } else if (type === 'page') {
          omniture = extend({}, omniture, {
            channel: '',
            pageName: `${siteSlug}:page:${get(staticPageData, 'slug')}`,
            pageURL: `${get(siteConfig, 'url')}/${get(staticPageData, 'slug')}`,
            prop1: '',
            prop2: '',
            prop3: '',
            prop4: `${get(siteConfig, 'url')}/${get(staticPageData, 'slug')}`,
            prop5: '',
            prop6: '',
            prop7: '',
            prop8: '',
            prop9: '',
            prop10: '',
            prop11: '',
            prop22: `anonymous:${siteSlug}:page:${get(staticPageData, 'slug')}`,
            prop28: 'page',
            prop31: '',
            prop32: '',
            prop33: '',
            prop34: ''
          });
        } else if (type === 'personPage') {
          const personSlug = get(personPageData, 'data.rows[0].url');
          omniture = extend({}, omniture, {
            channel: 'mcp',
            pageName: `${siteSlug}:person:${personSlug}`,
            pageURL: `${get(siteConfig, 'url')}/person/${personSlug}`,
            url: `${get(siteConfig, 'url')}/person/${personSlug}`,
            prop1: '',
            prop2: '',
            prop3: '',
            prop4: `${get(siteConfig, 'url')}/person/${personSlug}`,
            prop5: '',
            prop6: '',
            prop7: '',
            prop8: '',
            prop9: '',
            prop10: '',
            prop11: '',
            prop22: `anonymous:${siteSlug}:person:${personSlug}`,
            prop28: '',
            prop31: '',
            prop32: '',
            prop33: '',
            prop34: ''
          });
        } else if (type === 'mostCreativePeoplePage') {
          const year = get(mostCreativePeoplePageData, 'year');
          omniture = extend({}, omniture, {
            channel: 'mcp',
            pageName: (year) ? `${siteSlug}:mcp:${year}` : `${siteSlug}:mcp:front`,
            pageURL: `${get(siteConfig, 'url')}/most-creative-people/${year}`,
            url: `${get(siteConfig, 'url')}/most-creative-people/${year}`,
            prop1: '',
            prop2: '',
            prop3: '',
            prop4: `${get(siteConfig, 'url')}/most-creative-people/${year}`,
            prop5: '',
            prop6: '',
            prop7: '',
            prop8: '',
            prop9: '',
            prop10: '',
            prop11: '',
            prop22: `anonymous:${siteSlug}:page:mcp`,
            prop28: 'mcp',
            prop31: '',
            prop32: '',
            prop33: '',
            prop34: ''
          });
        } else if (type === 'ibdPage') {
          const year = get(ibdPageData, 'year');
            omniture = extend({}, omniture, {
              channel: 'ibd',
              pageName: (year) ? `${siteSlug}:ibd:${year}` : `${siteSlug}:ibd:front`,
              pageURL: `${get(siteConfig, 'url')}/innovation-by-design/${year}`,
              url: `${get(siteConfig, 'url')}/innovation-by-design/${year}`,
              prop1: '',
              prop2: '',
              prop3: '',
              prop4: `${get(siteConfig, 'url')}/innovation-by-design/${year}`,
              prop5: '',
              prop6: '',
              prop7: '',
              prop8: '',
              prop9: '',
              prop10: '',
              prop11: '',
              prop22: `anonymous:${siteSlug}:page:ibd`,
              prop28: 'ibd',
              prop31: '',
              prop32: '',
              prop33: '',
              prop34: ''
            });

          }
        // BUG: paging back and forth the status keeps going to 404
        // if (statusCode && statusCode === 404) {
        //   omniture = extend({}, omniture, {
        //     channel: 'Error Page',
        //     pageType: 'errorPage',
        //     pageName: ``,
        //     events: '',
        //     prop1: '',
        //     prop2: '',
        //     prop3: '',
        //     prop4: get(siteConfig, 'url'),
        //     prop5: '',
        //     prop6: '',
        //     prop7: '',
        //     prop8: '',
        //     prop9: '',
        //     prop10: '',
        //     prop11: '',
        //     prop13: 1,
        //     prop21: '',
        //     prop22: ``,
        //     prop23: '',
        //     prop31: true,
        //     prop32: 404,
        //     prop33: '',
        //     prop34: ''
        //   });
        // }
        // Send to Omniture
        map(omniture, function (value, key) {
          window.fastco_s[key] = value;
        });
        // Track page number
        if (pageNumber) {
          //sEvent needs to be in proper format, example event24 where 24 is the number corresponding to event set up in Omniture reporting
          window.fastco_s.linkTrackVars = 'events';
          window.fastco_s.linkTrackEvents = 'event31';
          window.fastco_s.events = 'event31';
          window.fastco_s.tl(this, 'o', pageNumber);
        }
        window.fastco_s.t();
      }
    }
  }

  // config here: https://analytics.google.com/analytics/web/#management/Settings/a45063514w75598220p78098335/%3Fm.page%3DPropertySettings/
  static loadGA(currentState) {
    if(canUseDOM) {
      // https://developers.google.com/analytics/devguides/collection/analyticsjs/
      if (window.ga) {
        ga = window.ga;
        // Disable autotrack stuff for now
        ga('send', 'pageview');
        ga('rollup.send', 'pageview');
      }
    }
  }

  static fbTracking(currentState) {
    if(canUseDOM) {
      const site = get(currentState, 'context.site');
      const facebookConfig = get(analyticsConfig[site], 'facebookPixel');
      const {id} = facebookConfig;

      // https://www.facebook.com/ads/manager/pixel/facebook_pixel/?act=1375631352670761&pid=p1
      if (window.fbq) {
        return false;
      }

      let fbq = window.fbq;
      fbq = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };

      if (!window._fbq) {
        window._fbq = fbq;
      }

      fbq.push = fbq;
      fbq.loaded = !0;
      fbq.version = '2.0';
      fbq.queue = [];

      fbq('init', `${id}`);
      fbq('track', 'PageView');
    }
  }

  static setThirdPartyGlobals(currentState) {
    if(canUseDOM) {
      window.ga = window.ga || function () {
          (ga.q = ga.q || []).push(arguments);
        };

      window.fbAsyncInit = function facebookInitialized() {
        FB.init({
          appId: '',
          xfbml: true,
          version: 'v2.7'
        });
      };

      window.twttr = window.twttr || {};

      window.___gcfg = {
        lang: 'en',
        parsetags: 'explicit'
      };

      window.googletag = window.googletag || {};
      window.googletag.cmd = window.googletag.cmd || [];

      window.amzn_ps_tracking_id = "";
      window.amzn_ps_instance_id = "";
    }
  }

  static loadComscore(currentState) {
    let site = get(currentState, 'context.site') || 'fastcompany';
    const comscoreConfig = get(analyticsConfig[site], 'comscore');
    const {c1, c2, publisherId} = comscoreConfig;

    if (site) {
      site = site.toUpperCase();
    } else {
      site = window.location.hostname;
    }
    // reset COMSCORE
    if (window.COMSCORE && window.COMSCORE.beacon) {
      window.COMSCORE.beacon({
        c1,
        c2,
        options: {
          url_append: 'comscorekw=' + site
        }
      });
      axios.get('/comscore_ping')
      .catch((error) => {
        log.error(error, 'Comscore page view candidate failed');
      });
    }
  }

  static loadNielsen(currentState) {
    if(canUseDOM) {
      const site = get(currentState, 'context.site');
      const nielsenConfig = get(analyticsConfig, `${site}.nielsen`);
      const {clientId} = nielsenConfig; // Do we need this?

      if (window.Nielsen_Event) {
        window.Nielsen_Event();
      }
    }
  }

  static loadKrux(currentState) {
    if(canUseDOM) {
      const siteName = get(currentState, 'context.site');
      const context = get(currentState, 'context');
      const siteConfig = analyticsConfig[siteName];
      const keywords = get(siteConfig, 'keywords') || [];

      const {postData, type} = context;

      if (window.Krux) {
        let FC_Krux_FPA = {
          author: null,
          channels: null,
          subChannels: null,
          contentType: null,
          keywords: null,
          socialTags: null,
          siteName: null,
          referrerUrl: null,
          url: window.location.origin + window.location.pathname,
          querystring: null
        };

        let category = null;
        let authorName = siteName || '';
        let contentType = type;
        let tags = [];
        let articleId = null;

        const typeMap = {
          post: 'article',
          gallery: 'slideshow',
          video: 'video'
        };

        // DO POST CHECK
        if (type === 'post') {
          category = get(postData, 'categories[0].slug') || '';
          authorName = get(postData, 'author.name') || '';
          contentType = typeMap[get(postData, 'format')] || 'article';
        }

        // FC_Krux_FPA['Read Length'] = null;  // todo @zhi
        FC_Krux_FPA['Article ID'] = (articleId) ? articleId : '';
        FC_Krux_FPA['Subchannel'] = category;
        FC_Krux_FPA['Channel'] = category;

        if (window.location.search !== '') {
          FC_Krux_FPA.querystring = window.location.search;
        }

        if (document.referrer) {
          FC_Krux_FPA.referrerUrl = document.referrer;
        }

        FC_Krux_FPA.channels = keywords;
        FC_Krux_FPA.siteName = siteName;

        FC_Krux_FPA.author = authorName;
        FC_Krux_FPA.subChannels = category;
        FC_Krux_FPA.keywords = tags;
        FC_Krux_FPA.socialTags = tags;
        FC_Krux_FPA.contentType = contentType;

        window.FC_Krux_FPA = FC_Krux_FPA;

        if (window.Krux) {
          // eslint-disable-next-line new-cap
          window.Krux('ns:mansueto', 'page:load', function () {
          }, {pageView: true});
        }
      }
    }
  }

  // IS current state used here?
  static loadParsely(currentState) {
    if(canUseDOM) {
      if (window.PARSELY && window.PARSELY.beacon) {
        const url = window.location.href;
        const navHistory = get(currentState, 'config.navHistory') || [];
        // console.log('parsely: ' + navHistory[navHistory.length - 1]);
        window.PARSELY.beacon.trackPageView({
          url,
          urlref: navHistory[navHistory.length - 1],
          js: 1
        });
      }
    }
  }
}

export function loadAllThirdPartyJs(currentState, pageNumber) {
  if(canUseDOM) {
    return P.all([
      ThirdPartyJs.loadGA(currentState),
      ThirdPartyJs.fbTracking(currentState),
      ThirdPartyJs.loadOmniture(currentState, pageNumber),
      ThirdPartyJs.loadComscore(currentState),
      ThirdPartyJs.loadNielsen(currentState),
      ThirdPartyJs.loadKrux(currentState),
      ThirdPartyJs.loadParsely(currentState)
    ]);
  }
  return P.resolve([]);
}

export function sendComscoreCandidatePing() {
  // figure out domain site name and deal with subdomains etc
  const hostNameSplit = window.location.hostname.split('.');
  let site = (hostNameSplit.length === 2) ? hostNameSplit[0] : hostNameSplit[1];
  const comscoreConfig = get(analyticsConfig[site], 'comscore');
  const {c1, c2, publisherId} = comscoreConfig;

  if (site) {
    site = site.toUpperCase();
  }
  // reset COMSCORE
  if (window.COMSCORE && window.COMSCORE.beacon) {
    window.COMSCORE.beacon({
      c1,
      c2,
      options: {
        url_append: 'comscorekw=' + site
      }
    });
    axios.get('/comscore_ping')
    .catch((error) => {
      log.error(error, 'Comscore page view candidate failed');
    });
  }
}

export function trackGAEvent(eventParams) {
  if(canUseDOM) {
    if (window && window.ga) {
      const {eventCategory, eventAction, eventLabel = null} = eventParams;
      if (eventCategory && eventAction) {
        window.ga('send', 'event', eventCategory, eventAction, eventLabel);
        window.ga('rollup.send', 'event', eventCategory, eventAction, eventLabel);
      }
    }
  }
}

export function trackOmniture(sEvent, sValue) {
  if (canUseDOM) {

    if (!window.fastco_s) {
        // console.error('Omniture not initialized, please include omniture s_code.js');
        return;
    }

    if (!sEvent || !sValue) {
        // console.error('Tracking parameters not provided');
        return;
    }

    //sEvent needs to be in proper format, example event24 where 24 is the number corresponding to event set up in Omniture reporting
    window.fastco_s.linkTrackVars = 'events';
    window.fastco_s.linkTrackEvents = sEvent;
    window.fastco_s.events = sEvent;
    window.fastco_s.tl(this, 'o', sValue);
  }
}



// WEBPACK FOOTER //
// ./src/client/utils/third_party_js_util.js